<template>
  <div class="content">
    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard' }">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Nueva Notificación</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container-fluid">
      <b-row>
        <b-col class="col-3">
          <b-card>
            <TreeNotificaciones :selectedComponent="notificacion.currentComponentBody" @node="selected" />
          </b-card>
          <div>
            <b-img
              v-if="notificacion.currentComponentBody === 'Solicitantes'"
              :src="require('@/assets/img/notificaciones/help/2_solicitantes_1.webp')"
              fluid-grow
              alt="Descripción de solicitantes"
            ></b-img>
            <b-img
              v-if="notificacion.currentComponentBody === 'Ubicacion'"
              :src="require('@/assets/img/notificaciones/help/3_domicilio_a_notificar.webp')"
              fluid-grow
              alt="Descripción de la ubicación a notificar"
            ></b-img>
            <b-img
              v-if="notificacion.currentComponentBody === 'Documentos'"
              :src="require('@/assets/img/notificaciones/help/1_documentos_abre_modal_1.webp')"
              fluid-grow
              alt="Descripción de los documentos a notificar"
            ></b-img>
            <b-button
              v-if="notificacion.currentComponentBody === 'Documentos'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-descripcion-documentos')"
            >
              Más información
            </b-button>
            <b-img
              v-if="notificacion.currentComponentBody === 'Cotizacion'"
              :src="require('@/assets/img/notificaciones/help/4_cotizacion.webp')"
              fluid-grow
              alt="Descripción de la cotización"
            ></b-img>
          </div>
        </b-col>

        <b-col class="col-9">
          <b-card>
            <b-row>
              <b-col class="col-12">
                <div v-if="notificacion.currentComponentBody === 'Solicitantes'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveSolicitantes)">
                      <Solicitantes :notificacion="notificacion" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="notificacion.currentComponentBody === 'Ubicacion'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(postDomicilio)" @change="getAddressInMap(null)">
                      <DomicilioNotificacion :disableFields="disableDomicilioFields" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="notificacion.currentComponentBody === 'Documentos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveDocumentos)">
                      <Documentos @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="notificacion.currentComponentBody === 'Cotizacion'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(confirmaCotizacion)">
                      <Cotizacion @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-route" hide-footer id="modal-confirm-dialog-route">
      <h4 class="text-center">¿Seguro que quiere salir de la página?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-route')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="beforeLeave(true)">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere salir sin guardar los cambios?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-cotizacion" hide-footer id="modal-confirm-cotizacion">
      <h4 class="text-center">¿Seguro que quiere continuar al pago?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-cotizacion')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="generaCotizacion()">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop id="modal-help-descripcion-documentos" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-notificaciones-1" :interval="0" indicators background="#ababab">
          <b-carousel-slide
            :img-src="require('@/assets/img/notificaciones/help/modal_1_notificaciones_descripcion_documentos.webp')"
          ></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <b-modal no-close-on-backdrop id="modal-help-descripcion-documentos" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-notificaciones-1" :interval="0" indicators background="#ababab">
          <b-carousel-slide
            :img-src="require('@/assets/img/notificaciones/help/modal_1_notificaciones_descripcion_documentos.webp')"
          ></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-datos-existentes" hide-footer size="md">
      <h4 class="text-center">Actualmente existe información llenada previamente, ¿Desea continuar con los mismos datos?</h4>
      <b-button class="mt-3" variant="danger" @click="cleanPreviousInfo">No, limpiar la información.</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="hideModalDatosExistentes">
        Continuar con la información previa.
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import TreeNotificaciones from "@/views/clients/procesos/notificaciones/TreeNotificaciones.vue";
import Cotizacion from "@/views/clients/procesos/notificaciones/infoBase/Cotizacion.vue";
import Documentos from "@/views/clients/procesos/notificaciones/infoBase/Documentos.vue";
import Solicitantes from "@/views/clients/procesos/notificaciones/infoBase/Solicitantes.vue";
import NoCobertura from "@/components/Toastification/Notificaciones/NoCobertura.vue";
import DomicilioNotificacion from "./infoBase/DomicilioNotificacion.vue";

import {
  ClientesApi,
  DocumentosApi,
  DocumentosXServiciosApi,
  DomiciliosApi,
  FuncionesApi,
  NotificacionesApi,
  NotificadosApi,
  SolicitantesApi,
} from "@/api";
import { getGoogleMapUrl } from "@/utils/google-maps-utils";
import Storage from "@/utils/storage";

import { useNotificacionStore } from "@/stores";

const storage = new Storage();

export default {
  name: "AddNotificaciones",

  components: {
    Solicitantes,
    DomicilioNotificacion,
    Documentos,
    TreeNotificaciones,
    Cotizacion,
  },

  setup() {
    const notificacion = useNotificacionStore();

    return { notificacion };
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === "EditNotificaciones") {
      next();
      return;
    }

    this.next = next;
    this.$refs["modal-confirm-dialog-route"].show();
  },

  mounted() {
    if (this.notificacion.solicitantes.length > 0) {
      this.showModalDatosExistentes();
      return;
    }

    this.notificacion.initNotificacionStore();
  },

  data: () => ({
    // ui state
    loading: false,

    // router
    next: null,

    // Objeto para desactivar o poner campos como readonly
    disableDomicilioFields: {
      disablePais: true,
    },
  }),

  methods: {
    showModalDatosExistentes() {
      this.$refs["modal-datos-existentes"]?.show();
    },

    hideModalDatosExistentes() {
      this.$refs["modal-datos-existentes"].hide();
    },

    cleanPreviousInfo() {
      this.notificacion.deleteStore();
      this.notificacion.initNotificacionStore();
      this.hideModalDatosExistentes();
    },

    beforeLeave(answer) {
      if (answer) {
        this.next();
      }
    },

    async selected(node) {
      const keys = Object.keys(this.notificacion.currentComponentValues);
      const values = Object.values(this.notificacion.currentComponentValues);
      const maps = this.notificacion.currentComponentValuesMaps;
      const dest = keys.find((value) => value == node);
      const currentIndex = keys.findIndex((value) => value == this.notificacion.currentComponentBody);
      const destIndex = keys.findIndex((value) => value == node);
      const lastCompletedIndex = values.lastIndexOf(true);

      // Ir mas adelante
      if (destIndex > currentIndex) {
        // Dest verde
        if (this.notificacion.currentComponentValues[dest]) {
          this.notificacion.currentComponentBody = dest;
        }
        // Dest amarillo
        else {
          let lastCompleted = keys[lastCompletedIndex + 1];
          if (destIndex - lastCompletedIndex === 1) {
            this.notificacion.currentComponentBody = dest;
          } else {
            if (lastCompletedIndex === -1) {
              lastCompleted = keys[0];
            }
            this.$toast.warning("Completa la sección '" + maps[lastCompleted] + "' para poder continuar", {
              timeout: 3000, //false,
              hideProgressBar: false,
              position: "top-right",
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              closeButton: "button",
              icon: true,
            });
          }
        }
      }
      // Ir mas atras
      else {
        this.notificacion.currentComponentBody = dest;
      }
    },

    async getAddressInMap(direcciones_id) {
      if (direcciones_id === null) {
        const address = `${this.notificacion.currentDomicilio.calle},${this.notificacion.currentDomicilio.num_exterior},${this.notificacion.currentDomicilio.colonia},
            ${this.notificacion.currentDomicilio.delegacion_municipio},${this.notificacion.currentDomicilio.codigo_postal},${this.notificacion.currentDomicilio.ciudad},
            ${this.notificacion.currentDomicilio.entidad}`;
        const mapUrl = await getGoogleMapUrl(address);

        if (!mapUrl) {
          return;
        }

        this.notificacion.currentDomicilio.lat = mapUrl.lat.toString(); //parseFloat(mapUrl.lat);
        this.notificacion.currentDomicilio.lng = mapUrl.lng.toString(); //parseFloat(mapUrl.lng);
      }
    },

    async postDomicilio() {
      try {
        this.loading = true;

        const { nombre_zona, costo } = await FuncionesApi.mapIntersect({
          lat: this.notificacion.currentDomicilio.lat,
          lng: this.notificacion.currentDomicilio.lng,
        });

        if (nombre_zona === "c" || nombre_zona === "d") {
          this.$toast.warning("Para realizar una Notificación en esta zona, por favor contáctate con un asesor vía telefónica", {
            timeout: 20000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });
        } else if (nombre_zona === "e") {
          this.$toast.info(NoCobertura, {
            timeout: false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });
        } else if (nombre_zona === "a" || nombre_zona === "b") {
          this.notificacion.currentComponentValues.Ubicacion = true;
          this.notificacion.costo_zona = costo;
          this.notificacion.currentComponentBody = "Documentos";
          this.notificacion.cotizacion.conceptos.domicilio_notificacion.zona = nombre_zona;
          this.notificacion.cotizacion.conceptos.domicilio_notificacion.precio = costo;
        }
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    saveSolicitantes() {
      if (this.notificacion.solicitantes.length === 0) {
        this.$toast.warning("Debe ingresar un solicitante.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      this.notificacion.currentComponentValues.Solicitantes = true;
      this.notificacion.setComponentBody("Ubicacion");
    },

    saveDocumentos() {
      if (this.notificacion.documentos.length === 0) {
        this.$toast.warning("Debe ingresar al menos 1 documento.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      this.notificacion.contenido_digital = this.notificacion.documentos.some((d) => d.digital);
      this.notificacion.currentComponentValues.Documentos = true;
      this.notificacion.currentComponentBody = "Cotizacion";
    },

    confirmaCotizacion() {
      this.$refs["modal-confirm-cotizacion"].show();
    },

    async generaCotizacion() {
      this.loading = true;

      let cliente_id = 0;

      try {
        const clienteEmail = storage.getItem("user");
        const { id } = await ClientesApi.clienteId(clienteEmail);

        cliente_id = id;
      } catch (error) {
        this.loading = false;

        console.log(error);
        this.$toast.error("Sucedió un error al obtener información del cliente, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      this.notificacion.currentComponentValues.Cotizacion = true;

      // Genera Notificacion en BD
      try {
        let fad_api = 0;
        if (this.notificacion.fad) {
          fad_api = 1;
        }
        let acta_express_extra = 0;
        if (this.notificacion.acta_express) {
          acta_express_extra = 1;
        }
        let envio_domicilio_api = 0;
        if (this.notificacion.envio_domicilio) {
          envio_domicilio_api = 1;
        }
        let contenido_digital_api = 0;
        if (this.notificacion.contenido_digital) {
          contenido_digital_api = 1;
        }

        this.notificacion.cotizacion.precio_total = this.notificacion.cotizacion.conceptos.costo_total;

        const { id, id_cotizaciones } = await NotificacionesApi.create({
          id_clientes: cliente_id,
          fad: fad_api,
          acta_express_extra: acta_express_extra,
          envio: envio_domicilio_api,
          contenido_digital: contenido_digital_api,
          corredurias_id: 17,
          clausulas_confirmacion: this.notificacion.clausulas_confirmacion,
          cotizacion: this.notificacion.cotizacion,
          referencia: this.notificacion.referencia,
        });

        this.notificacion.id = id;
        this.notificacion.id_cotizaciones = id_cotizaciones;
      } catch (error) {
        this.loading = false;

        console.log(error);
        this.$toast.error("Sucedió un error al generar la notificación, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      // Agrega notificado en BD
      try {
        const { id, id_domicilios } = await NotificadosApi.create({
          id_notificaciones: this.notificacion.id,
        });
        this.notificacion.notificado.id = id;
        this.notificacion.notificado.id_domicilios = id_domicilios;
      } catch (error) {
        this.loading = false;

        console.log(error);
        this.$toast.error("Sucedió un error al generar notificado, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      // Editar Domicilio en BD
      try {
        const { id } = await DomiciliosApi.edit(this.notificacion.notificado.id_domicilios, {
          calle: this.notificacion.currentDomicilio.calle,
          num_exterior: this.notificacion.currentDomicilio.num_exterior,
          num_interior: this.notificacion.currentDomicilio.num_interior,
          colonia: this.notificacion.currentDomicilio.colonia,
          delegacion_municipio: this.notificacion.currentDomicilio.delegacion_municipio,
          ciudad: this.notificacion.currentDomicilio.ciudad,
          entidad: this.notificacion.currentDomicilio.entidad,
          pais: this.notificacion.currentDomicilio.pais,
          codigo_postal: this.notificacion.currentDomicilio.codigo_postal,
          extranjero: 0,
          tipo: "Personal",
          tieneExtranjero: null,
          tieneTipo: null,
          lat: this.notificacion.currentDomicilio.lat,
          lng: this.notificacion.currentDomicilio.lng,
          valido: 1,
          comentario: null,
          validador: null,
        });
        this.notificacion.currentDomicilio.id = id;
      } catch (error) {
        this.loading = false;

        console.log(error);
        this.$toast.error("Sucedió un error al editar domicilio, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      // Agrega solicitantes
      this.notificacion.solicitantes.forEach((solicitante) => {
        if (!("cliente_id" in solicitante)) {
          solicitante.cliente_id = cliente_id;
        }
        if (!("signatario" in solicitante)) {
          solicitante.signatario = 0;
        }

        solicitante.id_notificaciones = this.notificacion.id;
      });

      try {
        const { id } = await SolicitantesApi.postClonados({
          solicitantes: this.notificacion.solicitantes,
        });
      } catch (error) {
        this.loading = false;

        console.log(error);
        this.$toast.error("Sucedió un error al crear cotización, intente más tarde", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return;
      }

      // Agrega documentos
      await this.agregaDocumentos();

      const notificacionId = this.notificacion.id;
      this.notificacion.deleteStore();
      this.$router.push({ name: "EditNotificaciones", params: { id: notificacionId } });
    },

    async agregaDocumentos() {
      // let documento_id = 41;
      // if (this.notificacion.solicitantes[0].persona == 'Moral') {
      //   documento_id = 42;
      //   const poderRepresentante = {
      //     catDocumentos_id: 40,
      //     paginas: 1
      //   }
      //   this.notificacion.documentos.push(poderRepresentante);
      // }
      // let inePrincipal = {
      //   catDocumentos_id: documento_id,
      //   paginas: 1,
      // }

      // this.notificacion.documentos.push(inePrincipal);

      for (const documento of this.notificacion.documentos) {
        if (!documento.anexoDe) {
          await this.postDocumento(documento);
        }
      }
    },

    async postDocumento(documento) {
      try {
        this.loading = true;

        let descripcion = null;

        if (documento.catDocumentos_id == 36) {
          descripcion = documento.tipo;
        }

        const { id } = await DocumentosApi.create({
          documento: null,
          cat_documentos_id: documento.catDocumentos_id,
          auto_referencia: documento.anexoDe_nuevo,
          descripcion: descripcion,
          paginas: parseInt(documento.paginas),
          copias_certificadas: null,
          nombre: null,
        });

        documento.nuevo_id = id;

        const index = this.notificacion.documentos.findIndex((o) => o.id === documento.id);

        if (this.notificacion.documentos[index + 1]) {
          if (this.notificacion.documentos[index + 1].anexoDe) {
            this.notificacion.documentos[index + 1].anexoDe_nuevo = documento.nuevo_id;
            await this.postDocumento(this.notificacion.documentos[index + 1]);
          }
        }

        await DocumentosXServiciosApi.create({
          documentos_id: documento.nuevo_id,
          cat_servicios_id: 2,
          proceso_id: this.notificacion.id,
        });
      } catch (error) {
        this.$toast.error("Sucedió un error al crear los documentos, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
